import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitReferral = (data) => axios.post(`${API}/referrals`, data);
export const submitConsultation = (data) => axios.post(`${API}/consultations`, data);
export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const adminLogin = (email, password) => axios.post(`${API}/auth/login`, { email, password });
export const getSubmissions = (token) =>
  axios.get(`${API}/admin/submissions`, { headers: { Authorization: `Bearer ${token}` } });

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return "Something went wrong. Please try again.";
};
